import { Injector } from '@angular/core';

let appInjector: Injector | null = null;

export function setAppInjector(injector: Injector): void {
    appInjector = injector;
}

export function getAppInjector(): Injector {
    if (!appInjector) {
        throw new Error('App injector has not been set');
    }

    return appInjector;
}
